export default __webpack_public_path__ + "static/media/fullcard.f36c29ba.svg";